<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)" color="#004889">
            <v-card flat color="#004889">
                <v-card-text class="pa-0">
                    <ValidationObserver ref="observer1">
                        <v-form ref="personalform">
                            <v-list flat color="#004889" class="py-0">
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">First Name</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="First Name" rules="required">
                                            <v-text-field
                                            v-model="form.first_name"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Last Name</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required">
                                            <v-text-field
                                            v-model="form.last_name"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Email</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Email" rules="email">
                                            <v-text-field
                                            v-model="form.email"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Phone</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                                            <v-text-field
                                            v-model="form.phone"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Street Address</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Street Address" rules="required">
                                            <v-text-field
                                            v-model="form.street_address"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">City</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                            <v-text-field
                                            v-model="form.city"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">ZIP Code</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Zip Code" rules="required">
                                            <v-text-field
                                            v-model="form.zip"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">County</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="County" rules="required">
                                            <v-autocomplete
                                                :items="counties"
                                                :filter="customFilter"
                                                :error-messages="errors"
                                                v-model="form.county"
                                                color="white"
                                                item-text="title"
                                                item-value="id"
                                                label="County"
                                                required
                                                solo
                                                flat
                                                dark
                                            ></v-autocomplete>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-form>
                    </ValidationObserver>
                </v-card-text> 
                <v-card-actions>
                    <v-btn large min-width="100%" color="white accent--text"  @click="submit" :loading="loading" tile>Create</v-btn>
                </v-card-actions> 
            </v-card>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    data () {
        return {
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                street_address: '',
                city: '',
                state: 'AL',
                zip: '',
                service: 'New Pool - CRM',
                county: null,
                status: 'confirmed'
            },
            pageTitle: '',
            loading: false
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
    },
    computed: {
        ...mapGetters({
            counties: 'data/counties',
            states: 'data/states',
        }),
    },
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    methods: {
        ...mapActions({
            addCustomer: 'data/addCustomer'
        }),
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.addCustomer(this.form).then(response => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    if(this.$route.params.redirect == 'New Job') {
                        this.$router.push({ name: this.$route.params.redirect, params: { customer: response.customer } })
                    } else {
                        this.$router.push({ name: 'Customer', params: { id: response.id, newjob: true } })
                    }
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
    }
}
</script>